import React from "react";
import { Box, Paper, Typography } from "@mui/material";

function AuthCard({ title, subtitle, children }) {
  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 64px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Paper elevation={2} sx={{ width: "100%", maxWidth: 460, p: 3 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            {subtitle}
          </Typography>
        ) : null}
        {children}
      </Paper>
    </Box>
  );
}

export default AuthCard;
